/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Page, Layout, TextStyle, Banner, Button } from '@shopify/polaris';
import { ExternalSmallMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import queryString from 'query-string';

import { routes } from 'src/routes';
import history from 'src/routes/history';
import { getThemeReviewUrl } from 'src/helpers';
import { startSABLoading, stopSABLoading } from 'src/integrations/shopify-app-bridge/loading';
import { StepProgress } from 'src/components/views/installation/step-progress';
import { URL } from 'src/constants/links';

import * as installActions from 'actions/install-actions';

type Props = WithI18nProps;
// DONE
class SetupComplete extends Component<Props, State> {
  state = {
    themeId: '',
    themeName: ''
  };

  componentDidMount() {
    const queries = queryString.parse(this.props.location.search);
    const { themeName, themeId } = queries;
    if (_.isEmpty(themeId)) {
      const { getInstallStatus } = this.props;
      getInstallStatus();
    } else {
      this.setState({ themeName, themeId });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loading && !this.props.loading) {
      startSABLoading();
    }

    if (!nextProps.loading && this.props.loading) {
      stopSABLoading();
    }

    if (this.props.loading && !nextProps.loading && nextProps.success) {
      const { themeId } = this.state;
      if (_.isEmpty(themeId)) {
        const { installThemeId, installThemeName } = nextProps;
        this.setState({ themeName: installThemeName, themeId: installThemeId });
      }
    }
  }

  render() {
    const { themeName } = this.state;
    const { i18n } = this.props;
    return (
      <div className="BC-AnotherLayout">
        <Page
          title={i18n.translate('AdminHTML.Installation.ThreeDashSetupComplete.pageTitle')}
          primaryAction={
            <div className="step-progress-initializing">
              <StepProgress step={4} />
            </div>
          }>
          <Layout>
            <Layout.Section>
              <Banner
                title={i18n.translate('AdminHTML.Installation.ThreeDashSetupComplete.bannerTitle')}
                status="success"
                action={{
                  content: i18n.translate(
                    'AdminHTML.Installation.ThreeDashSetupComplete.buttonChildren'
                  ),
                  onAction: this.handlePreview
                }}>
                <p>
                  {i18n.translate('AdminHTML.Installation.ThreeDashSetupComplete.paragraph1', {
                    nt_theme_name: <TextStyle variation="strong">{themeName}</TextStyle>
                  })}
                </p>
                <br />
                <p>{i18n.translate('AdminHTML.Installation.ThreeDashSetupComplete.paragraph2')}</p>

                <br />
                <p className="enableTAE">
                  <TextStyle>
                    {i18n.translate('AdminHTML.ThemeSetup.ThemeSetup.bottomTextTAE', {
                      t1: (
                        <a
                          href={URL['EnableAppBlockTAE']}
                          target="_blank"
                          rel="noopener noreferrer">
                          {i18n.translate('AdminHTML.ThemeSetup.ThemeSetup.bottomTextTAE_t1')}
                        </a>
                      ),
                      externalIcon: (
                        <span className="external-link">
                          <Button icon={ExternalSmallMinor} plain />
                        </span>
                      )
                    })}
                  </TextStyle>
                </p>
              </Banner>
            </Layout.Section>
          </Layout>
        </Page>
      </div>
    );
  }

  // Handle preview filter action
  handlePreview = async () => {
    const { themeId } = this.state;
    const previewUrl = getThemeReviewUrl(themeId);
    const { updateInstallationStatus } = this.props;

    window.open(previewUrl, '_blank');
    await updateInstallationStatus('');
    history.push(routes.verifySetup.view());
  };
}

const mapStateToProps = (state, props) => ({
  loading: state.install.loading,
  success: state.install.success,
  installThemeId: state.install.installThemeId,
  installThemeName: state.install.installThemeName
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getInstallStatus: () => dispatch(installActions.getInstallStatus(ownProps.i18n)),
  updateInstallationStatus: status => dispatch(installActions.updateInstallationStatus(status))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(SetupComplete));
